import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p>
        La tua privacy è importante per noi. Questa informativa sulla privacy spiega quali dati personali raccogliamo dai nostri utenti e come li utilizziamo.
      </p>
      <h2 className="text-xl font-bold mt-4">Informazioni che raccogliamo</h2>
      <p>
        Raccogliamo informazioni personali che ci fornisci direttamente, come nome, indirizzo email, numero di telefono e messaggi inviati tramite il modulo di contatto o WhatsApp.
      </p>
      <h2 className="text-xl font-bold mt-4">Come utilizziamo le informazioni</h2>
      <p>Utilizziamo le informazioni raccolte per:</p>
      <ul className="list-disc list-inside">
        <li>Rispondere alle tue richieste e fornire assistenza</li>
        <li>Migliorare il nostro servizio</li>
        <li>Inviare comunicazioni di marketing (con il tuo consenso)</li>
      </ul>
      <h2 className="text-xl font-bold mt-4">Condivisione delle informazioni</h2>
      <p>
        Non condividiamo le tue informazioni personali con terze parti, eccetto nei casi in cui sia necessario per fornire il servizio o richiesto dalla legge.
      </p>
      <h2 className="text-xl font-bold mt-4">I tuoi diritti</h2>
      <p>
        Hai il diritto di accedere, rettificare o cancellare i tuoi dati personali. Puoi contattarci per esercitare questi diritti.
      </p>
      <h2 className="text-xl font-bold mt-4">Contatti</h2>
      <p>
        Per domande sulla nostra politica sulla privacy, contattaci su WhatsApp.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
